import * as React from 'react';
import { useSelector } from 'react-redux';

import { OldFiltersContainer } from './OldFiltersContainer';
import { DesktopFiltersMicrofrontend } from '../DesktopFiltersMicrofrontend/DesktopFiltersMicrofrontend';
import { IAppState } from 'shared/common/state';
import { FiltersSection } from 'shared/components/FiltersSection';
import { EPosition } from 'shared/filters/components/filters/types';
import { TTag } from 'shared/filters/state/tags';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const FiltersContainer: React.FC = () => {
  const appContext = useApplicationContext();

  const isDesktopFiltersMicrofrontendEnabled = appContext.config.get<boolean>('desktopFiltersMicrofrontend.Enabled');

  const tags = useSelector<IAppState, TTag[]>(state => state.filters.tags);

  const [filtersSectionPosition, setFiltersSectionPosition] = React.useState<EPosition>(EPosition.default);
  const updateFiltersHeightCb = React.useRef<() => void | undefined>();

  const setUpdateHeightCb = React.useCallback((cb: () => void) => {
    updateFiltersHeightCb.current = cb;
  }, []);

  React.useEffect(() => {
    // при изменении кол-ва тегов, запускаем пересчет мин-высоты плавающих фильтров
    if (updateFiltersHeightCb.current) {
      updateFiltersHeightCb.current();
    }
  }, [tags]);

  return (
    <FiltersSection
      position={filtersSectionPosition}
      setUpdateHeightCb={setUpdateHeightCb}
      onChangePosition={setFiltersSectionPosition}
    >
      {isDesktopFiltersMicrofrontendEnabled ? (
        <DesktopFiltersMicrofrontend filtersSectionPosition={filtersSectionPosition} />
      ) : (
        <OldFiltersContainer filtersSectionPosition={filtersSectionPosition} />
      )}
    </FiltersSection>
  );
};
